import { useTranslation } from 'react-i18next';
import '../../../styles/components/subscriptionPackages/agency/agencyPackages.scss';
import { useState } from 'react';
import CustomSVGs from '../../../ui/customSVGs/CustomSVGs';
import { tickWithCircleSVG } from '../../../lib/allCustomSVGs';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import isNotEmptyString from '../../../lib/helper-functions/isNotEmptyString';
import AgencyPackageItem from './AgencyPackageItem';

type Props = {
  taraSubscriptionPackages: any[];
};

const AgencyPackages = ({ taraSubscriptionPackages }: Props) => {
  const { t } = useTranslation();
  const [isMonthly, setIsMonthly] = useState<boolean>(true);
  const [isSupportPopupOpen, setIsSupportPopupOpen] = useState<boolean>(false);
  const paymentPopupTemporaryMessage = useSelector(
    (state: RootState) => state.UI.paymentPopupTemporaryMessage
  );

  // <-- New: filter packages by role -->
  const packagesByRole = taraSubscriptionPackages.filter(
    (pkg) => pkg.role === 'agency'
  );

  return (
    <>
      {isSupportPopupOpen ? (
        <div className='agencyPackages--support'>
          <h3>{t('EmailSentSuccessfully')}</h3>
          <CustomSVGs svg={tickWithCircleSVG} />
        </div>
      ) : (
        <div className='agencyPackages'>
          <div className='agencyPackages__titles'>
            <h2>{t('Plans&Prices')}</h2>
            <p>{t('ChoosePlan-subtext-agency')}</p>
          </div>

          <div className='agencyPackages__banner'>
            <div className='agencyPackages__banner--left'>
              <h3>{t('TaraPackageBannerText1Agency')}</h3>
              <p>{t('TaraPackageBannerText2Agency')}</p>
            </div>
          </div>

          {isNotEmptyString(paymentPopupTemporaryMessage) && (
            <div
              className='collapseList__item--top-left-tag collapseList__item--top-left-tag-yellow'
              style={{
                width: 'fit-content',
                marginBottom: '2.5rem',
                fontSize: '1.4rem',
              }}
            >
              {paymentPopupTemporaryMessage}
            </div>
          )}

          {/* {((taraSubscriptionDetails &&
            taraSubscriptionDetails?.currentSubscriptionStatus === 'none') ||
            !taraSubscriptionDetails) &&
            userRole === 'agency' && (
              <div className='agencyPackages__progressBar'>
                <ProgressBarPlus
                  progress={32}
                  totalSpots={100}
                  // spotsRemaining={34}
                  // title='Early Bird Special'
                  availabilityLabel='Capacity'
                  limitText={t('TaraPackageProgressBarText')}
                />
              </div>
            )} */}

          {/* Toggle only for sellers */}

          <div className='agencyPackages__selection'>
            <div className='agencyPackages__selection--text'>
              {t('PayMonthly')}
            </div>
            <div className='agencyPackages__selection--toggle'>
              <input
                className='agencyPackages__selection--toggle-input'
                type='checkbox'
                id='mode-toggle'
                checked={!isMonthly}
                onChange={() => setIsMonthly((m) => !m)}
              />
              <label
                className='agencyPackages__selection--toggle-label'
                htmlFor='mode-toggle'
              />
            </div>
            <div className='agencyPackages__selection--text'>
              {t('PayAnnually')}
            </div>
            <div className='agencyPackages__selection--info'>
              {`25%  ${t('Cheaper')}`}
            </div>
          </div>

          {/* Render exactly 3 packages filtered by role */}
          <div className='agencyPackages__items'>
            {packagesByRole.map((packageDetails) => (
              <AgencyPackageItem
                key={packageDetails.id}
                isMonthly={isMonthly}
                packageDetails={packageDetails}
                setIsSupportPopupOpen={setIsSupportPopupOpen}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default AgencyPackages;
